/* 
	该模块是用于定义action对象中type类型的常量值，目的只有一个：便于管理的同时防止程序员单词写错
*/
export const SHOW_NAVBAR = 'show_navbar'
export const TREE_SEARCH = 'tree_search'
export const TOKEN_CHECK = 'token_check'
export const ALERT_SHOW = 'alert_show'